<template lang="pug">

  div

    //-
      -
      - Modal CRIAR ESCALA
      -
      -

    v-dialog(v-model="isVisible" max-width="500px" width="100%" persistent)

      .dialogHeader

        .dialogHeaderTitle
          | Nova escala

        .dialogHeaderClose
          .dialogCloseButton.mdi.mdi-close(@click="close(false)")

      .dialogBody

        .dialogBodyContent

          .createTurnField.createTurnField--first
            label.csLabel
              span(v-html="'Nome da escala'")
            .csFields
              input(v-model="scaleName" :disabled="loading" class="sosInput" maxlength="64" placeholder="Entre 1 e 64 caracteres")

          .fieldError(v-if="error.name")
            | Digite um nome de até 64 caracteres.

          //- [staging-portaltelemedicina / master-portaltelemedicina]
          //- .createTurnField(style="position: relative; z-index: 7")
            sos-select(label="Tempo de consulta" :items="[{ key: '0', value: '0', text: 'Desativado' }, { key: '06', value: '6', text: '6 minutos' }, { key: '10', value: '10', text: '10 minutos' }, { key: '15', value: '15', text: '15 minutos' }, { key: '20', value: '20', text: '20 minutos' }, { key: '30', value: '30', text: '30 minutos' }, { key: '60', value: '60', text: '60 minutos' }]" @sosSelectChanged="onSelectConsultationDuration" :default="scaleConsultationDuration" :disabled="loading")

          //- .createTurnField(style="position: relative; z-index: 6")
            sos-select(label="Obrigar a inclusão de paciente?" :items="[{ key: '1', value: '1', text: 'Sim' }, { key: '0', value: '0', text: 'Não' }]" @sosSelectChanged="onSelectPatientRequiredOption" :default="requirePatient" :disabled="loading")
          //- [staging-portaltelemedicina / master-portaltelemedicina]

          div(v-if="presetLocations")

            .createTurnField
              sos-select(label="Local" :items="locations" @sosSelectChanged="handleLocationSelection" :default="locationID" :disabled="loading")

            span.fieldNote
              b Nota:
              |  O grupo tem locais pré-definidos. Clique no campo acima para escolher um local.

          div(v-else)

            .createTurnField
              label.csLabel
                span(v-html="'Local'")
              .csFields
                input(v-model="locationName" :disabled="loading" class="sosInput" maxlength="64" placeholder="Deixe vazio ou informe um local entre 3 e 64 caracteres")

            span.fieldNote
              b Nota:
              |  O grupo não tem locais pré-definidos. Você pode informar um local personalizado.

          .fieldError(v-if="error.local")
            | Limpe o nome do local ou digite um nome de 3 a 64 caracteres.

          .createTurnField.createTurnField--last
            label.csLabel
              span(v-html="'Valor por hora'")
            .csFields
              app-money-light(:value="hourlyRate" :blur-event="onBlurScaleValue" :disabled="loading")

          .createTurnField
            label.csLabel
              span(v-html="'Número máximo de plantões por usuário'")
            .csFields
              input(v-model="maxDutiesPerUser" :disabled="loading" class="sosInput" maxlength="4" placeholder="Deixe vazio ou informe uma quantidade de 1 a 9999" @input="onScaleMaxShiftsChange(maxDutiesPerUser)")

          .fieldError(v-if="error.maxShifts")
            | Limpe o campo ou digite uma quantidade menor que 9999.

          .createTurnField
            label.csLabel
              span(v-html="'Dia de início da escala no mês'")
            .csFields
              input(v-model="firstDayOfMonth" :disabled="loading" class="sosInput" maxlength="2" placeholder="Deixe vazio ou informe um dia do mês" @input="onScaleStartDayOfMonth(firstDayOfMonth)")

          .fieldError(v-if="error.startDay")
            | Informe um número entre 1 e 31.

          .createTurnField
            label.csLabel
              span(v-html="'Dia de término da escala no mês seguinte'")
            .csFields
              input(v-model="lastDayOfMonth" :disabled="loading" class="sosInput" maxlength="2" placeholder="Deixe vazio ou informe um dia do mês" @input="onScaleEndDayOfMonth(lastDayOfMonth)")

          .fieldError(v-if="error.endDay")
            | Informe um número entre 1 e 31.

          .dialogSubtitle
            | PREFERÊNCIAS

          //- [staging-portaltelemedicina / master-portaltelemedicina]
          //- .preLocais
            .locaisMsg
              | Mostrar vagas apenas de plantões assumidos:
            sos-switch(:value="slotsFromOwnedDutiesOnly" @click="onToggleSlotsFromOwnedDutiesOnly" :disabled="loading")
          //- [staging-portaltelemedicina / master-portaltelemedicina]

          .preLocais
            .locaisMsg
              | Começar semana na Segunda-feira:
            sos-switch(:value="startOnMonday" @click="onChangeCalendarMode" :disabled="loading")

          .preLocais
            .locaisMsg
              | Cor dos plantões assumidos:
            .colorPickerButton(@click="openOwnedShiftsColorPicker" :style="{ 'background-color': ownedDutyColor }")

          .fieldError(v-if="error.ownedShiftsColor")
            | Escolha uma cor para os plantões assumidos.
          .fieldError.mb-4(v-if="error.ownedShiftWhite")
            | A cor é muito clara! Escolha um tom mais escuro.

          .preLocais
            .locaisMsg
              | Cor dos plantões livres:
            .colorPickerButton(@click="openAvailableShiftsColorPicker" :style="{ 'background-color': availableDutyColor }")

          .fieldError.mb-4(v-if="error.availableShiftsColor")
            | Escolha uma cor para os plantões disponiveis.
          .fieldError.mb-4(v-if="error.availableShiftWhite")
            | A cor é muito clara! Escolha um tom mais escuro.

          .fieldError.mb-4(v-if="error.sameShiftsColor && (!error.availableShiftWhite && !error.ownedShiftWhite)")
            | Escolha uma cor diferente para plantões disponíveis e assumidos.

          .text-right.mt-5
            sos-button(@buttonClick="close(false)" size="medium" buttonLabel="Fechar" buttonIcon="mdi-close" buttonIconSize="16" color="blue" :disabled="loading").mr-3
            sos-button(@buttonClick="createScale" size="medium" buttonLabel="Criar" buttonIcon="mdi-plus" buttonIconSize="16" color="success" :disabled="loading")

    //-
      -
      - Modal AVISO
      -
      -

    confirm-dialog(ref="cdConfirmModal" :title="cdParameters.title" :text="cdParameters.text" :buttonPosition="cdParameters.buttonPosition" :width="cdParameters.width" @close="cdAction")

    //-
      -
      - Modal SOS COLOR PICKER
      -
      -

    sos-color-picker(ref="dialogAvailableColorPicker" @close="onAvailableShiftsColorPickerClose")
    sos-color-picker(ref="dialogOwnedColorPicker" @close="onOwnedShiftsColorPickerClose")

</template>

<script>

  import { isLightColor } from '@/functions'
  import { validateLocationName } from '@/functions/groups'
  import { validateScaleName } from '@/functions/scales'

  import AppMoneyLight from '@/components/base/AppMoneyLight'
  import SosSelect from '@/components/SosSelect'
  import SosButton from '@/components/SosButton'
  import SosSwitch from '@/components/SosSwitch'
  import ConfirmDialog from '@/modals/ConfirmDialog'
  import SosColorPicker from '@/modals/SosColorPicker'

  import { apiCreateScale } from '@/services/endpoints/scales'

  import confirmDialogMixin from '@/mixins/cd.mixin.js'

  export default {
    name: 'ScaleCreate',

    components: {
      'app-money-light': AppMoneyLight,
      'sos-select': SosSelect,
      'sos-button': SosButton,
      'sos-switch': SosSwitch,
      'confirm-dialog': ConfirmDialog,
      'sos-color-picker': SosColorPicker,
    },

    mixins: [
      confirmDialogMixin,
    ],

    data () {
      return {
        isVisible: false,
        loading: false,

        presetLocations: false,
        locations: [],

        error: {
          name: false,
          local: false,
          maxShifts: false,
          availableShiftsColor: false,
          ownedShiftsColor: false,
          sameShiftsColor: false,
          availableShiftWhite: false,
          ownedShiftWhite: false,
        },

        scaleName: '',
        locationID: "",
        locationName: "",
        maxDutiesPerUser: 0,
        firstDayOfMonth: 0,
        lastDayOfMonth: 0,
        hourlyRate: 0,

        startOnMonday: true,

        availableDutyColor: '#00cb72',
        ownedDutyColor: '#2196f3',

        /*
        // [staging-portaltelemedicina / master-portaltelemedicina]
        scaleConsultationDuration: '0',
        requirePatient: '1',
        slotsFromOwnedDutiesOnly: false,
        // [staging-portaltelemedicina / master-portaltelemedicina]
        */
      }
    },

    // created () {
    // },

    // mounted () {
    // },

    beforeDestroy () {
      this.clear()
    },

    // unmounted () {
    // },

    methods: {
      //
      // GESTÃO DO POPUP + DADOS
      //

      reset () {
        this.isVisible = false
        this.loading = false
        this.presetLocations = false
        this.locations = []

        this.error = {
          name: false,
          local: false,
          maxShifts: false,
          startDay: false,
          endDay: false,
          availableShiftsColor: false,
          ownedShiftsColor: false,
          sameShiftsColor: false,
          availableShiftWhite: false,
          ownedShiftWhite: false,
        }

        this.scaleName = ""
        this.locationID = ""
        this.locationName = ""
        this.hourlyRate = 0
        this.maxDutiesPerUser = 0
        this.firstDayOfMonth = 0
        this.lastDayOfMonth = 0
        this.startOnMonday = true
        this.availableDutyColor = '#00cb72'
        this.ownedDutyColor = '#2196f3'

        /*
        // [staging-portaltelemedicina / master-portaltelemedicina]
        this.scaleConsultationDuration = '0'
        this.requirePatient = '1'
        this.slotsFromOwnedDutiesOnly = false
        // [staging-portaltelemedicina / master-portaltelemedicina]
        */

        // cd.mixin.js
        this.cdParameters = { title: '', text: '', buttonPosition: 'right', width: 330 }
      },

      clear () {
        this.reset()

        delete this.isVisible
        delete this.loading
        delete this.presetLocations
        delete this.locations
        delete this.error
        delete this.scaleName
        delete this.locationID
        delete this.locationName
        delete this.hourlyRate
        delete this.maxDutiesPerUser
        delete this.startOnMonday
        delete this.availableDutyColor
        delete this.ownedDutyColor

        /*
        // [staging-portaltelemedicina / master-portaltelemedicina]
        delete this.scaleConsultationDuration
        delete this.requirePatient
        delete this.slotsFromOwnedDutiesOnly
        // [staging-portaltelemedicina / master-portaltelemedicina]
        */

        // cd.mixin.js
        delete this.cdParameters
      },

      open (group)
      {
        this.presetLocations = !!group.fixLocais

        this.locations = group.groupLocations.length > 0 ? group.groupLocations.map(l => ({
          key: 'scaleLocation_' + l.groupPlaceID,
          value: l.groupPlaceID,
          text: `${l.groupPlaceName}${l.isGroupLocationGeofenced ? ` <span class="scLocationStatus" data-active="true"> - Área: ${l.groupPlaceRadius} metros</span>` : ' <span class="scLocationStatus" data-active="false"> - Área: Desativada</span>'}`,
        })) : []

        /*
        // [staging-portaltelemedicina / master-portaltelemedicina]
        this.scaleConsultationDuration = '0'
        this.requirePatient = '1'
        this.slotsFromOwnedDutiesOnly = false
        // [staging-portaltelemedicina / master-portaltelemedicina]
        */

        this.isVisible = true
      },

      close (confirmed = false) {
        this.reset()
        this.$emit('close', confirmed)
      },

      //
      //
      //

      openAvailableShiftsColorPicker () {
        this.$refs.dialogAvailableColorPicker.open(this.availableDutyColor)
      },

      openOwnedShiftsColorPicker () {
        this.$refs.dialogOwnedColorPicker.open(this.ownedDutyColor)
      },

      onAvailableShiftsColorPickerClose (action) {
        if (!!action === false) return false

        this.availableDutyColor = action
      },

      onOwnedShiftsColorPickerClose (action) {
        if (!!action === false) return false

        this.ownedDutyColor = action
      },

      //
      // FIELD ERROR HANDLING
      //

      resetErrors () {
        this.error.name = false
        this.error.local = false
        this.error.maxShifts = false
        this.error.startDay = false
        this.error.endDay = false
        this.error.availableShiftsColor = false
        this.error.ownedShiftsColor = false
        this.error.sameShiftsColor = false
        this.error.availableShiftWhite = false
        this.error.ownedShiftWhite = false
      },

      getErrors () {
        return this.error
      },

      setError (error, status = true) {
        this.error[error] = status
      },

      //
      // CREATE SCALE
      //

      async createScale ()
      {
        //
        // SANITIZE/PREPARE SOME DATA
        //

        const name = String(this.scaleName).trim()
        const maxDutiesPerUser = Number(this.maxDutiesPerUser)
        const firstDayOfMonth = Number(this.firstDayOfMonth)
        const lastDayOfMonth = Number(this.lastDayOfMonth)
        const availableDutyColor = String(this.availableDutyColor).toUpperCase()
        const ownedDutyColor = String(this.ownedDutyColor).toUpperCase()

        //
        // VALIDATE FIELDS
        //

        this.resetErrors()

        // VERIFICA SE O NOME DA ESCALA FOI PREENCHIDO CORRETAMENTE
        if (!validateScaleName(name)) this.setError('name')

        // VERIFICA SE O LOCAL PERSONALIZADO FOI PREENCHIDO CORRETAMENTE (NOTA: ISSO ACONTECE APENAS SE O GRUPO NÃO TEM LOCAIS PRÉ-DEFINIDOS)
        if (this.presetLocations && this.locationName.length > 0 && !validateLocationName(this.locationName)) this.setError('local')

        // VERIFICA SE EXISTE QUANTIDADE MÁXIMA DE PLANTÕES POR USUÁRIO, SE SIM, DEVE SER MENOR QUE 10000
        if (maxDutiesPerUser > 9999) this.setError('maxShifts')

        // VERIFICA SE O DIA DO MÊS DE INÍCIO DO PLANTÃO É VÁLIDO (ENTRE 1 E 31)
        if (firstDayOfMonth && (firstDayOfMonth < 1 || firstDayOfMonth > 31)) this.setError('startDay')

        // VERIFICA SE O DIA DO MÊS DE TÉRMINO DO PLANTÃO É VÁLIDO (ENTRE 1 E 31)
        if (lastDayOfMonth && (lastDayOfMonth < 1 || lastDayOfMonth > 31)) this.setError('endDay')

        //  IS AVAILABLE SHIFT HEXADECIMAL COLOR VALID?
        if (!/^#[A-Fa-f0-9]{6}$/i.test(availableDutyColor)) this.setError('availableShiftsColor')
        // VERIFICA SE A COR DOS PLANTÕES DISPONÍVEIS É BRANCO
        if (isLightColor(availableDutyColor, 80)) this.setError('availableShiftWhite')

        //  IS OWNED SHIFT HEXADECIMAL COLOR VALID?
        if (!/^#[A-Fa-f0-9]{6}$/i.test(ownedDutyColor)) this.setError('ownedShiftsColor')
        // VERIFICA SE A COR DOS PLANTÕES ASSUMIDOS É BRANCO
        if (isLightColor(ownedDutyColor, 80)) this.setError('ownedShiftWhite')

        // ARE OWNED AND AVAILABLE SHIFTS COLOR THE SAME?
        if (availableDutyColor === ownedDutyColor) this.setError('sameShiftsColor')

        const { name: nameError, local, maxShifts, startDay, endDay, availableShiftsColor, ownedShiftsColor, sameShiftsColor, availableShiftWhite, ownedShiftWhite } = this.getErrors()

        if (nameError || local || maxShifts || startDay || endDay || availableShiftsColor || ownedShiftsColor || sameShiftsColor || availableShiftWhite || ownedShiftWhite) return false

        //
        // CREATE
        //

        const { groupID } = this.$route.params
        const { hourlyRate, locationID, locationName, startOnMonday } = this

        this.loading = true

        const response = await apiCreateScale(groupID, {
          name, // Nome da escala
          hourlyRate, // Valor hora da escala
          locationID, // Identificador do local
          locationName, // Nome do local
          startOnMonday, // Começar semana na Segunda-feira ?
          maxDutiesPerUser, // Número máximo de plantões por usuário
          firstDayOfMonth, // Dia de início da escala no mês
          lastDayOfMonth, // Dia de término da escala no mês seguinte
          availableDutyColor, // Cor dos plantões livres
          ownedDutyColor, // Cor dos plantões assumidos

          /*
          // [staging-portaltelemedicina / master-portaltelemedicina]
          consultationDuration: this.scaleConsultationDuration, // Tempo de consulta
          requirePatient: this.requirePatient, // Obrigar a inclusão de paciente?
          slotsFromOwnedDutiesOnly: this.slotsFromOwnedDutiesOnly, // Mostrar vagas apenas de plantões assumidos
          // [staging-portaltelemedicina / master-portaltelemedicina]
          */
        })

        this.loading = false

        if (response.httpCode !== 201) {
          this.showMessage(response.title, response.message)
        } else {
          this.showDialog(response.title, response.message, 'close-modal', '', true, 'right', 400, true)
        }
      },

      //
      // SELECTS EVENTS
      //

      handleLocationSelection (locationID)
      {
        // SE O GRUPO NÃO TEM LOCAIS PRÉ-DEFINIDOS, ENTÃO O GESTOR PODE ATRIBUIR UM LOCAL PERSONALIZADO (TEXTO LIVRE)
        // SE O GRUPO TEM LOCAIS PRÉ-DEFINIDOS, ENTÃO O GESTOR SÓ PODE ATRIBUIR UM DESSES LOCAIS

        const placeFound = this.locations.find(l => l.value === locationID)

        this.locationID = placeFound ? placeFound.value : ""
        this.locationName = placeFound ? placeFound.text.split(' <span class="scLocationStatus"')[0] : ""
      },

      /*
      // [staging-portaltelemedicina / master-portaltelemedicina]
      onSelectConsultationDuration (value) {
        this.scaleConsultationDuration = value
      },

      onSelectPatientRequiredOption (value) {
        this.requirePatient = value
      },

      onToggleSlotsFromOwnedDutiesOnly (value) {
        this.slotsFromOwnedDutiesOnly = value
      },
      // [staging-portaltelemedicina / master-portaltelemedicina]
      */

      onBlurScaleValue (hourlyRate) {
        this.hourlyRate = hourlyRate
      },

      onScaleMaxShiftsChange (inputText) {
        if (!/^\d+$/.test(inputText) || /^0+/.test(inputText)) {
          const newString = inputText.trim().replace(/[^\d]+/g, '').replace(/^0+/, '')
          this.maxDutiesPerUser = newString.length > 0 ? newString : '0'
        }
      },

      onScaleStartDayOfMonth (inputText) {
        if (!/^\d+$/.test(inputText) || /^0+/.test(inputText)) {
          const newString = inputText.trim().replace(/[^\d]+/g, '').replace(/^0+/, '')
          this.firstDayOfMonth = newString.length > 0 ? newString : '0'
        }
      },

      onScaleEndDayOfMonth (inputText) {
        if (!/^\d+$/.test(inputText) || /^0+/.test(inputText)) {
          const newString = inputText.trim().replace(/[^\d]+/g, '').replace(/^0+/, '')
          this.lastDayOfMonth = newString.length > 0 ? newString : '0'
        }
      },

      onChangeCalendarMode () {
        this.startOnMonday = !this.startOnMonday
      },

      //
      // CONFIRM DIALOG OUTPUT/RESPONSE
      //

      cdAction (action)
      {
        // Fecha a janela
        if (action.cdType === "close-modal") {
          this.close(true)
        }
      },
    },
  }

</script>

<style lang="scss" scoped>
  .dialogSubtitle {
    margin: 30px 0 20px 0;
    font-weight: bold;
  }

  .preLocais {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    min-width: 100% !important;
    padding-bottom: 12.5px;
  }

  .locaisMsg {
    color: #777777;
    // font-size: 14px;
    font-weight: 400;
    // color: #495057;
    font-size: 15px;
    // font-weight: 500;
    line-height: 35px;
  }

</style>
